
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.003 21.645c-.5-1.8-1.9-3.7-3.4-2.1-1.2 1.2-.8 3.3-.1 4.9-.9.8-1.8 1.7-2.7 2.5-1-.9-2.8-.8-4.1-.4-1.5.4-3 .8-4.4 1.4-.7-.7-1.4-1.2-2.4-1.5-.8-.2-1.9-.2-2.6-.7-1-.6-2.2-2.6-3.7-1.9-.4-.9-.8-1.8-1.3-2.7 1-1 1.8-2.3 1.3-3.7-.5-1.7-2.6-1.9-3.6-.6-1.2-.5-2.9-.2-3.2 1.1-.6 2.2 1.9 3.7 3.7 3.9.3 0 .6.1.7 0 .1.1.1.3.1.3.4.8.8 1.6 1.1 2.4 0 .1.1.1.1.2-.5.8-.8 1.8-.9 2.7-3-3.3-9.7-3.5-12.8-.3-1.3-2.5-3.6-4.3-7.1-3.1-2.9 1-4.2 4.6-4.1 7.4 0 1.1.4 2.1.9 2.9h-.8c-1 0-.7 2.2-.5 2.7 1 2.5 2.1 4.9 3.1 7.4.1.2.3.5.5.5h37.1c.2 0 .4-.3.5-.5 1-2.5 2.1-4.9 3.1-7.4.2-.5.5-2.7-.5-2.7h-.9c.5-1.1 1-2.2 1.3-3.5.2-.7.2-1.5.1-2.2 1-.9 1.9-1.8 2.9-2.7 1.6.5 4.5 1.4 5.5-.3 1.4-2.1-.8-4-2.9-4zm-28.2-2.7c.4 0 .8 0 1.2.2.3.2.5-.3.6-.5.1-.3.9-.4 1.2-.4.7 0 .8.1.6.5-.1.3-.7.7-1 .9-1.1.1-1.8-.3-2.6-.7zm5.6 10c.5 1.1 1-.9.7-1.6.8.5 1.4 1.4 2.3 1.8.7.2 1.3.4 2 .5-1.4 1.2-2.4 2.7-2.6 4.7h-3.9c-.3-2-.6-6.2.6-7.2.4.6.7 1.2.9 1.8zm-3 2c0 1.1 0 2.3.2 3.4H17.003c-.2-1.4-.6-3-1.1-4.6 3-2.5 9.6-2.2 11.5 1.2zm-22.4-.2c.1-3 3.5-4.3 6-3.7 2.9.7 4 4.4 4.5 7.3h-7.4c-1.4-.7-3.1-2-3.1-3.6zm38.7 10.9c-.1 0-.3 0-.6.1-1 .2-2.3 0-3.3 0h-28.5c-1.1 0-2.4.1-3.5 0-.4-.1-.6 0-.7 0l-.1-.1c-.9-.9-1.5-2.5-2-4.1h40.6c-.4 1.6-1 3.2-1.9 4.1zm1.3-9.4c-.3.7-.4 1.4-.6 2.2h-10c.4-1.5 2-2.5 3.7-3.2.1 0 .1 0 .2-.1 1.4-.5 2.9-.9 3.8-1.2.3-.1 1.2-.3 2.1-.4-.2.7.1 2.2.4 1.9.5-.5 1-.9 1.5-1.4-.3.5-1.1 2-1.1 2.2zm8.8-7.9c-1 0-2.1-.3-3.1-.6-.3-.4-.7-1.1-.7-1.6.1-1.6 2.4-.6 2.3.3 0 .2 0 1.5.5 1.4.7-.1 1.2.2 1.9.4.1 0 .3 0 .4.1h-1.3z"}})])
          )
        }
      }
    